export const MARGIN_RIGHT = 40;
export const MARGIN_TOP = 30;

export const MAX_POINTS_QUANTITY = 50;
export const MIN_POINTS_QUANTITY = 6;
